import { Step } from '~components/wizard-form/props';
// NB: import the wizard step components from their sub-module, not the ~appointments/components
// barrel. The barrel re-exports bulk-update-package-wizard, which imports these step files, so
// going via the barrel creates a circular dependency that resolves Confirm/Validate to undefined.
import { Confirm, Validate } from '~appointments/components/bulk-update-package-wizard';

import { getAll as getClients } from '~main/actions/clients';

import { selectClientPackages } from '~main/selectors/clients/clientPackages';
import { selectLookupClients } from '~main/selectors/clients/clients';

const steps: Step[] = [
  {
    step: 1,
    title: 'Criteria',
    fields: {
      date: {
        type: 'date-range',
        field: 'date',
        caption: 'Date',
        required: true,
        className: 'align-items-baseline',
      },
      client_id: {
        type: 'multi-lookup',
        field: 'client_id',
        caption: 'Clients',
        selectorOptions: selectLookupClients,
        selectorActions: getClients,
        required: false,
        className: 'align-items-baseline',
      },
      old_package_id: {
        type: 'select',
        field: 'old_package_id',
        caption: 'Package FROM',
        selectorOptions: selectClientPackages,
        required: true,
        className: 'align-items-baseline',
      },
      new_package_id: {
        type: 'select',
        field: 'new_package_id',
        caption: 'Package TO',
        selectorOptions: selectClientPackages,
        required: true,
        className: 'align-items-baseline',
      },
    },
  },
  {
    step: 2,
    title: 'Review',
    nextButtonCaption: 'Confirm/Proceed',
    fields: {
      review: {
        type: 'custom',
        component: Validate,
        colSize: 12,
        dependencies: ['date', 'old_package_id', 'new_package_id', 'client_id'],
      },
      warning: {
        type: 'alert-warning',
        deriveValue: () =>
          'Warning: If you proceed, all affected appointments will be immediately updated from old to new chosen package!',
        colSize: 12,
      },
    },
  },
  {
    step: 3,
    title: 'Confirm',
    showPrevButton: false,
    fields: {
      warning: {
        type: 'alert-warning',
        deriveValue: () =>
          'Warning: This update tool does not verify client package schedules. Please ensure all clients have valid package schedules before proceeding.',
        colSize: 12,
      },
      info: {
        type: 'alert-danger',
        deriveValue: () =>
          'Reverting changes may not be possible, and our support team may be unable to assist if errors occur.',
        colSize: 12,
      },
    },
  },
  {
    step: 4,
    title: 'Results',
    showPrevButton: false,
    fields: {
      confirm: {
        type: 'custom',
        component: Confirm,
        colSize: 12,
        dependencies: ['date', 'old_package_id', 'new_package_id', 'client_id'],
      },
    },
  },
];

export default steps;
